// src/components/loginpage/verificationsuccess/verificationsuccess.jsx
// Countdown logic unchanged. Markup rebuilt to the Modernist mockup: the video
// panel with the brand plate (an escape hatch the old page did not have), and a
// "Go to login now" action so the user is not forced to wait out the timer.
import React, { useEffect, useRef, useState } from 'react';
import './verificationsuccess.css';
import VideoMask from '../../landingpage/VideoMask';
import logoMark from '../../../assets/images/logo-mark.png';
import { kq } from '../../../config/routes';

const VerificationSuccess = ({
  title = "Verification Successful",
  message = "You are being redirected to the login page",
  redirectSeconds = 10,
  onRedirect,
  area = 'suite',
}) => {
  const loginPath = area === 'kuestion' ? kq('login') : '/login';
  const [secondsLeft, setSecondsLeft] = useState(redirectSeconds);
  const targetRef = useRef(Date.now() + redirectSeconds * 1000);
  const intervalRef = useRef(null);

  const redirectNow = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (typeof onRedirect === 'function') onRedirect();
    else window.location.replace(loginPath);
  };

  useEffect(() => {
    targetRef.current = Date.now() + redirectSeconds * 1000;

    const tick = () => {
      const msLeft = targetRef.current - Date.now();
      const sec = Math.max(0, Math.ceil(msLeft / 1000));
      setSecondsLeft(sec);
      if (sec <= 0) {
        clearInterval(intervalRef.current);
        if (typeof onRedirect === 'function') {
          onRedirect();
        } else {
          window.location.replace(loginPath);
        }
      }
    };

    tick(); // initial update
    intervalRef.current = setInterval(tick, 250);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [redirectSeconds, onRedirect, loginPath]);

  return (
    <div className="rw-split">
      <div className="rw-split__panel">
        <VideoMask />
        <div className="rw-split__panel-inner">
          <button
            type="button"
            className="rw-brand-plate"
            onClick={() => window.location.assign('/')}
            title="Back to Riftworks home"
          >
            <img src={logoMark} alt="Riftworks" />
            <span>
              <strong>RIFTWORKS</strong>
              <em>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12" />
                  <polyline points="12 19 5 12 12 5" />
                </svg>
                Back to home
              </em>
            </span>
          </button>
        </div>
      </div>

      <div className="rw-split__form">
        <div className="rw-verify">
          <span className="rw-verify__badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 5h16v14H4z" />
              <polyline points="4 6 12 13 20 6" />
            </svg>
          </span>
          <h1 className="rw-verify__title">{title}</h1>
          <p className="rw-verify__message">{message}.</p>
          <div className="rw-verify__rule" />
          <p className="rw-verify__countdown" aria-live="polite">
            Redirecting in <strong>{secondsLeft}</strong> second{secondsLeft === 1 ? '' : 's'}…
          </p>
          <button type="button" className="rw-verify__action" onClick={redirectNow}>
            Go to login now
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationSuccess;
